(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kvision-js-legacy', 'navigo'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kvision-js-legacy'), require('navigo'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-routing-navigo-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-routing-navigo-js-legacy'.");
    }if (typeof this['kvision-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-routing-navigo-js-legacy'. Its dependency 'kvision-js-legacy' was not found. Please, check whether 'kvision-js-legacy' is loaded prior to 'kvision-kvision-routing-navigo-js-legacy'.");
    }if (typeof Navigo === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-routing-navigo-js-legacy'. Its dependency 'navigo' was not found. Please, check whether 'navigo' is loaded prior to 'kvision-kvision-routing-navigo-js-legacy'.");
    }root['kvision-kvision-routing-navigo-js-legacy'] = factory(typeof this['kvision-kvision-routing-navigo-js-legacy'] === 'undefined' ? {} : this['kvision-kvision-routing-navigo-js-legacy'], kotlin, this['kvision-js-legacy'], Navigo);
  }
}(this, function (_, Kotlin, $module$kvision_js_legacy, $module$navigo) {
  'use strict';
  var routing = $module$kvision_js_legacy.io.kvision.routing;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var KVRouter = $module$kvision_js_legacy.io.kvision.routing.KVRouter;
  var RouterFactory = $module$kvision_js_legacy.io.kvision.routing.RouterFactory;
  var throwUPAE = Kotlin.throwUPAE;
  Routing.prototype = Object.create($module$navigo.prototype);
  Routing.prototype.constructor = Routing;
  function Routing(root, useHash, hash) {
    Routing$Companion_getInstance();
    if (root === void 0)
      root = null;
    if (useHash === void 0)
      useHash = true;
    if (hash === void 0)
      hash = '#!';
    $module$navigo.call(this, root, useHash, hash);
  }
  Routing.prototype.kvNavigate_61zpoe$ = function (route) {
    this.navigate(route);
  };
  Routing.prototype.kvOn_a1vqyy$ = function (route, handler) {
    this.on(route, handler);
    return this;
  };
  Routing.prototype.kvOff_5ij4lk$ = function (handler) {
    this.off(handler);
  };
  Routing.prototype.kvResolve = function () {
    this.resolve();
  };
  Routing.prototype.kvDestroy = function () {
    this.destroy();
  };
  function Routing$Companion() {
    Routing$Companion_instance = this;
  }
  Routing$Companion.prototype.init_ihwhoo$ = function (root, useHash, hash) {
    if (root === void 0)
      root = null;
    if (useHash === void 0)
      useHash = true;
    if (hash === void 0)
      hash = '#!';
    routing.RoutingManager.routerFactory = new NavigoRouterFactory(root, useHash, hash);
    var $receiver = new Routing(root, useHash, hash);
    $receiver.resolve();
    set_routing($receiver);
  };
  Routing$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var Routing$Companion_instance = null;
  function Routing$Companion_getInstance() {
    if (Routing$Companion_instance === null) {
      new Routing$Companion();
    }return Routing$Companion_instance;
  }
  Routing.$metadata$ = {kind: Kind_CLASS, simpleName: 'Routing', interfaces: [KVRouter]};
  function NavigoRouterFactory(root, useHash, hash) {
    if (root === void 0)
      root = null;
    if (useHash === void 0)
      useHash = true;
    if (hash === void 0)
      hash = '#!';
    this.root = root;
    this.useHash = useHash;
    this.hash = hash;
  }
  NavigoRouterFactory.prototype.getRouter = function () {
    return get_routing();
  };
  NavigoRouterFactory.prototype.initRouter = function () {
    set_routing(new Routing(this.root, this.useHash, this.hash));
  };
  NavigoRouterFactory.prototype.shutdownRouter = function () {
    get_routing().destroy();
  };
  NavigoRouterFactory.$metadata$ = {kind: Kind_CLASS, simpleName: 'NavigoRouterFactory', interfaces: [RouterFactory]};
  var routing_0;
  function get_routing() {
    if (routing_0 == null)
      return throwUPAE('routing');
    return routing_0;
  }
  function set_routing(routing) {
    routing_0 = routing;
  }
  Object.defineProperty(Routing, 'Companion', {get: Routing$Companion_getInstance});
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  var package$routing = package$kvision.routing || (package$kvision.routing = {});
  package$routing.Routing = Routing;
  package$routing.NavigoRouterFactory = NavigoRouterFactory;
  Object.defineProperty(package$routing, 'routing', {get: get_routing, set: set_routing});
  return _;
}));

//# sourceMappingURL=kvision-kvision-routing-navigo-js-legacy.js.map
